/* ==========================================================================
   Kleos — PDP Personalizar (flujo de personalización / fotograbado)
   Figma: desktop 17698-667 · móvil 17698-1448 (banda "ficha de producto").

   Qué hace (todo sin dependencias, se auto-inicializa una vez):
     · Galería: miniaturas sobre la imagen → swap de imagen principal.
     · Selector de oferta "Compra 1 / Compra 2" → sincroniza la cantidad del
       formulario (y el stepper) con la tarjeta elegida.
     · Stepper de cantidad (− / +).
     · Paso 1 (texto) y Paso 2 (archivo): line item properties. El archivo
       viaja como multipart al interceptar iurop-cart.js el submit del form
       (FormData → /cart/add.js) y Shopify lo sube a su CDN.
     · Validación de pasos obligatorios ANTES de que iurop-cart.js procese
       el submit (listener en el propio form: corta la propagación).
     · Cuenta atrás "Realiza tu pedido antes de las HH:MM" en la zona horaria
       configurada (por defecto Argentina).
     · Upsells "El 82% también se llevó": añade por AJAX y abre #CartDrawer
       (window.iuropCartDrawer.addItem + refresh + open).
     · Vídeos "Así lo recibís": play inline + barras de paginación.
     · Pestañas de descripción y carrusel de reseñas con barras.
     · Lightbox: click en la imagen principal → window.iuropLightbox.open(id)
       (snippets/iurop-lightbox.liquid, cargado por la sección).
     · Sticky ATC (#IuropStickyAtc): mismo patrón que iurop-product.js; el
       botón sticky hace click() sobre [data-pp-main-cta] para NO saltarse
       la validación; total = precio variante × cantidad (formatMoney).
     · Augmenta el side-cart: pinta las line item properties bajo cada línea
       (el chrome no se toca: MutationObserver sobre [data-cd-items]).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__iuropPersonalizarInit) return;
  window.__iuropPersonalizarInit = true;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- dinero (mismo contrato que iurop-product.js / iurop-cart.js) ---------- */
  function formatMoney(cents, format) {
    var f = format || '${{amount_with_comma_separator}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }
    var match = f.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return f.replace(placeholder, value);
  }

  /* ======================================================================
     0b. Total del sticky ATC — MISMO precio que la tarjeta de oferta
        seleccionada (qty 2 → pack con descuento visual, no contradecir la
        tarjeta). Sin tarjeta que case con la cantidad (stepper a 3+),
        fallback a precio de variante × cantidad.
     ====================================================================== */
  function syncStickyTotal(root) {
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount_with_comma_separator}}';
    var qtyInput = $('[data-pp-qty-input]', root);
    var n = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var text = null;
    var cards = $all('[data-pp-offer]', root);
    for (var i = 0; i < cards.length; i++) {
      var q = parseInt(cards[i].getAttribute('data-qty'), 10) || 1;
      if (q === n && cards[i].classList.contains('is-selected')) {
        var p = $('.iurop-pp__offer-price', cards[i]);
        if (p) text = p.textContent.trim();
        break;
      }
    }
    if (text == null) {
      var price = parseInt(root.getAttribute('data-pp-variant-price'), 10);
      if (!price) return;
      text = formatMoney(price * n, moneyFormat);
    }
    $all('[data-iurop-sticky-total]').forEach(function (el) { el.textContent = text; });
  }

  /* La galería de esta plantilla es un slider (markup [data-pp-thumb-btn] en
     sections/main-product-personalizar.liquid, con su propio JS inline). La
     antigua initGallery() —cambiaba el src de una única imagen— se eliminó en
     QA R17: su guard `if (!main) return` ya salía siempre. */


  /* ======================================================================
     2. Cantidad: selector de oferta + stepper
     ====================================================================== */
  function initQuantity(root) {
    var form = $('[data-pp-form]', root);
    if (!form) return;
    var qtyInput = $('[data-pp-qty-input]', form);
    var qtyLabel = $('[data-pp-qty-label]', form);
    var offers = $all('[data-pp-offer]', root);

    function setQty(n, fromOffer) {
      n = Math.max(1, parseInt(n, 10) || 1);
      if (qtyInput) qtyInput.value = n;
      if (qtyLabel) qtyLabel.textContent = n;
      // marca la tarjeta cuya cantidad coincide (si la hay)
      offers.forEach(function (o) {
        var q = parseInt(o.getAttribute('data-qty'), 10) || 1;
        var on = q === n;
        o.classList.toggle('is-selected', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      /* el total sticky espeja la tarjeta seleccionada (syncStickyTotal) */
      syncStickyTotal(root);
      if (!fromOffer) { /* cambio manual: nada más que sincronizar */ }
    }

    offers.forEach(function (o) {
      o.addEventListener('click', function () {
        setQty(o.getAttribute('data-qty'), true);
      });
    });
    var minus = $('[data-pp-qty-minus]', form);
    var plus = $('[data-pp-qty-plus]', form);
    if (minus) minus.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
    /* Arranca en la oferta que diga el ajuste "Preseleccionar la oferta 2";
       el Liquid ya pinta esa tarjeta marcada, así que no hay parpadeo. */
    var preselec = parseInt(root.getAttribute('data-pp-preselect') || '0', 10);
    setQty(preselec > 0 ? preselec : (qtyInput ? qtyInput.value : 1));
  }

  /* ======================================================================
     2b. Variantes: el <select> actualiza precio de cabecera, tachado, tag,
        tarjetas de oferta, aviso de stock, data-pp-variant-price y sticky.
        Los datos vienen en data-price / data-compare / data-low de cada
        <option> (server-rendered en la sección).
     ====================================================================== */
  function initVariants(root) {
    var select = $('[data-pp-variant-select]', root);
    if (!select) return;
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount_with_comma_separator}}';
    var pct = parseFloat(root.getAttribute('data-pp-offer-pct') || '0') || 0;

    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var price = parseInt(opt.getAttribute('data-price'), 10);
      if (!price) return;
      var compare = parseInt(opt.getAttribute('data-compare'), 10) || 0;

      root.setAttribute('data-pp-variant-price', String(price));

      /* cabecera: precio + tachado + tag %OFF */
      var priceEl = $('[data-pp-price]', root);
      if (priceEl) priceEl.textContent = formatMoney(price, moneyFormat);
      var compEl = $('[data-pp-compare]', root);
      var tagEl = $('[data-pp-tag]', root);
      if (compare > price) {
        if (compEl) { compEl.textContent = formatMoney(compare, moneyFormat); compEl.hidden = false; }
        if (tagEl) { tagEl.textContent = Math.round((compare - price) * 100 / compare) + '% OFF'; tagEl.hidden = false; }
      } else {
        if (compEl) compEl.hidden = true;
        if (tagEl) tagEl.hidden = true;
      }

      /* tarjetas de oferta: 1 ud y pack de 2 con el descuento visual */
      var o1 = $('[data-pp-o1-price]', root);
      if (o1) o1.textContent = formatMoney(price, moneyFormat);
      var packBase = price * 2;
      var packFinal = Math.round(packBase * (1 - pct / 100));
      var o2c = $('[data-pp-o2-compare]', root);
      if (o2c) o2c.textContent = formatMoney(packBase, moneyFormat);
      var o2p = $('[data-pp-o2-price]', root);
      var precio2 = pct > 0 ? packFinal : packBase;
      if (o2p) o2p.textContent = formatMoney(precio2, moneyFormat);

      /* Etiqueta de envío gratis: depende del TOTAL de cada opción, así que si
         la variante cambia de precio hay que re-evaluarla. Umbral en céntimos,
         el mismo del carrito. 0 = desactivada. */
      var envioUmbral = parseInt(root.getAttribute('data-pp-envio-umbral') || '0', 10);
      if (envioUmbral > 0) {
        var e1 = $('[data-pp-envio-1]', root);
        var e2 = $('[data-pp-envio-2]', root);
        if (e1) e1.hidden = price < envioUmbral;
        if (e2) e2.hidden = precio2 < envioUmbral;
      }

      /* aviso de urgencia de stock: solo si la variante está realmente baja */
      var stockEl = $('[data-pp-stock]', root);
      if (stockEl) stockEl.hidden = opt.getAttribute('data-low') !== '1';

      /* sticky: precio unitario + total (espeja la tarjeta seleccionada) */
      $all('[data-iurop-sticky-price]').forEach(function (el) {
        el.textContent = formatMoney(price, moneyFormat);
      });
      syncStickyTotal(root);
    });
  }

  /* ======================================================================
     3. Paso 2: subir archivo (estado + preview + quitar)
     ====================================================================== */
  function initUpload(root) {
    var wrap = $('[data-pp-upload]', root);
    if (!wrap) return;
    var input = $('input[type="file"]', wrap);
    var form = wrap.closest('form');
    var trigger = $('[data-pp-upload-trigger]', wrap);
    var idle = $('[data-pp-upload-idle]', wrap);
    var done = $('[data-pp-upload-done]', wrap);
    var nameEl = $('[data-pp-upload-name]', wrap);
    var thumb = $('[data-pp-upload-thumb]', wrap);
    var errEl = $('[data-pp-error-file]', root);
    var listEl = $('[data-pp-upload-list]', wrap);
    var countEl = $('[data-pp-upload-count]', wrap);
    var slots = $all('[data-pp-slot]', wrap);
    if (!input || !trigger) return;

    var MAX_BYTES = 20 * 1024 * 1024;      /* tope de Shopify por fichero */
    var MAX_FILES = parseInt(wrap.getAttribute('data-pp-max') || '10', 10);
    /* Fotos grandes de móvil: se reducen a 2400 px de lado (sobra para el
       grabado) y JPEG 0,9 si pasan de 1,5 MB. PNG/SVG no se recomprimen
       (logos con transparencia). */
    var REDUCIR_DESDE = 1.5 * 1024 * 1024;
    var LADO_MAX = 2400;
    var CALIDAD = 0.9;
    var colaCanvas = Promise.resolve();     /* decodificar/reducir de una en una */
    /* Cada entrada: { nombre, file (copia en memoria, null mientras se
       prepara), promesa }. La copia en memoria es la clave del arreglo: el
       selector de fotos de Android (nombres tipo 1001262896.jpg) entrega
       referencias cuyo contenido cambia al leerlas (quita la ubicación del
       EXIF), y Chrome aborta la subida con ERR_UPLOAD_FILE_CHANGED → el fetch
       falla y salía "No pudimos subir las fotos" en cada intento. */
    var elegidos = [];

    function tpl(el, attr, fallback) {
      return (el && el.getAttribute(attr)) || fallback;
    }
    function pesoLegible(b) {
      var kb = b / 1024;
      return kb > 1024 ? (kb / 1024).toFixed(1) + ' MB' : Math.ceil(kb) + ' KB';
    }
    function aviso(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = false;
    }

    /* Los inputs elegidos por el usuario se conservan intactos en el DOM.
       Android/Samsung puede entregar las fotos mediante referencias temporales:
       vaciar el input o reconstruir su FileList con DataTransfer invalida esas
       referencias y Chrome termina el submit con ERR_UPLOAD_FILE_CHANGED.

       Los slots aportan solamente los nombres "Diseño 1", "Diseño 2"... El
       carrito adjunta los File originales a FormData justo antes del fetch. */
    slots.forEach(function (slot) { slot.disabled = true; });
    function sincronizarEstado() {
      wrap.setAttribute('data-pp-selected-count', String(elegidos.length));
    }
    /* ---------- copia en memoria (+ reducción) de cada foto ---------- */
    function leerBytes(file) {
      if (file.arrayBuffer) return file.arrayBuffer();
      return new Promise(function (ok, ko) {
        var fr = new FileReader();
        fr.onload = function () { ok(fr.result); };
        fr.onerror = function () { ko(fr.error || new Error('read')); };
        fr.readAsArrayBuffer(file);
      });
    }
    function decodificar(blob) {
      return new Promise(function (ok, ko) {
        var url = URL.createObjectURL(blob);
        var img = new Image();
        img.onload = function () { URL.revokeObjectURL(url); ok(img); };
        img.onerror = function () { URL.revokeObjectURL(url); ko(new Error('decode')); };
        img.src = url;
      });
    }
    function aJpeg(img, nombre) {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (!w || !h) return Promise.reject(new Error('size'));
      var k = Math.min(1, LADO_MAX / Math.max(w, h));
      var c = document.createElement('canvas');
      c.width = Math.round(w * k); c.height = Math.round(h * k);
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height);
      ctx.drawImage(img, 0, 0, c.width, c.height);
      return new Promise(function (ok, ko) {
        if (!c.toBlob) return ko(new Error('toBlob'));
        c.toBlob(function (b) {
          c.width = c.height = 0;             /* iOS: libera la memoria del canvas */
          if (!b) return ko(new Error('toBlob'));
          ok(new File([b], nombre.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }));
        }, 'image/jpeg', CALIDAD);
      });
    }
    function preparar(file) {
      var tipo = file.type || '';
      var esFoto = /^image\/(jpe?g|webp)$/i.test(tipo) || (!tipo && /\.(jpe?g|webp)$/i.test(file.name));
      return leerBytes(file).then(function (buf) {
        var copia = new File([buf], file.name, { type: tipo || 'application/octet-stream' });
        if (!esFoto || copia.size <= REDUCIR_DESDE) return copia;
        var paso = colaCanvas.then(function () {
          return decodificar(copia).then(function (img) { return aJpeg(img, file.name); });
        });
        colaCanvas = paso.then(null, function () {});
        return paso
          .then(function (r) { return r.size < copia.size ? r : copia; })
          .catch(function () { return copia; });
      }, function () {
        /* No se pudo leer el fichero tal cual: último intento decodificándolo
           como imagen (otra ruta de lectura del navegador). */
        if (/svg/i.test(tipo)) throw new Error('read');
        return decodificar(file).then(function (img) { return aJpeg(img, file.name); });
      });
    }
    var huboIlegible = false;
    function todasListas() {
      if (errEl) errEl.hidden = true;        /* el aviso del intento anterior */
      return Promise.all(elegidos.map(function (e) { return e.promesa; })).then(function () {
        /* Si una foto resultó ilegible mientras se preparaba, se avisa una vez
           antes de añadir con menos fotos de las que eligió. */
        if (huboIlegible) {
          huboIlegible = false;
          var e1 = new Error('unreadable');
          e1.__iuropMsg = (errEl && errEl.textContent) || 'Alguna foto no se pudo leer. Elegila de nuevo.';
          throw e1;
        }
        var req = $('[data-pp-file][data-required]', wrap);
        if (req && !elegidos.length) {
          var e2 = new Error('required');
          e2.__iuropMsg = (errEl && errEl.getAttribute('data-msg-required')) || 'Subí tu diseño para continuar.';
          throw e2;
        }
      });
    }

    if (form) {
      /* iurop-cart.js espera a esta promesa antes de montar el FormData. */
      form.__iuropBeforeSubmit = todasListas;
      form.__iuropAppendFileProperties = function (formData) {
        elegidos.forEach(function (e, i) {
          var slot = slots[i];
          if (slot && slot.name && e.file) formData.append(slot.name, e.file, e.file.name);
        });
      };
      form.__iuropHandleCartError = function (err) {
        var msg = err && err.__iuropMsg;
        aviso(msg || 'No pudimos subir las fotos. Revisá tu conexión e intentá de nuevo.');
        try { trigger.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      };
    }

    function pintar() {
      if (listEl) {
        listEl.innerHTML = '';
        elegidos.forEach(function (e) {
          var f = e.file;
          var li = document.createElement('li');
          li.className = 'iurop-pp__upload-item';
          var img = document.createElement('img');
          img.className = 'iurop-pp__upload-thumb';
          img.alt = '';
          img.width = 32; img.height = 32;
          if (f && /^image\/(png|jpe?g|svg\+xml|webp)$/i.test(f.type)) {
            if (!e.thumb) e.thumb = URL.createObjectURL(f);
            img.src = e.thumb;
          } else img.hidden = true;
          var nom = document.createElement('span');
          nom.className = 'iurop-pp__upload-name';
          nom.textContent = e.nombre + ' · ' + (f ? pesoLegible(f.size) : '…');
          var quitar = document.createElement('button');
          quitar.type = 'button';
          quitar.className = 'iurop-pp__upload-clear';
          quitar.textContent = trigger.getAttribute('data-txt-quitar') || 'Quitar';
          quitar.addEventListener('click', function () {
            var i = elegidos.indexOf(e);
            if (i === -1) return;
            if (e.thumb) URL.revokeObjectURL(e.thumb);
            elegidos.splice(i, 1);
            sincronizarEstado();
            pintar();
          });
          li.appendChild(img); li.appendChild(nom); li.appendChild(quitar);
          listEl.appendChild(li);
        });
      }
      if (countEl) {
        var t = tpl(countEl, 'data-tpl', '[n] de [max] fotos');
        countEl.textContent = t.split('[n]').join(elegidos.length).split('[max]').join(MAX_FILES);
        countEl.hidden = elegidos.length === 0;
      }
      wrap.classList.toggle('has-file', elegidos.length > 0);
      /* Con el cupo lleno, el boton deja de invitar a seguir subiendo. */
      wrap.classList.toggle('is-full', elegidos.length >= MAX_FILES);
    }

    function anadir(files) {
      if (errEl) errEl.hidden = true;
      huboIlegible = false;
      var rechazadosPeso = 0, hueco = MAX_FILES - elegidos.length, tope = false;
      Array.prototype.slice.call(files).forEach(function (f) {
        if (elegidos.length >= MAX_FILES) { tope = true; return; }
        if (f.size > MAX_BYTES) { rechazadosPeso++; return; }
        /* Evita duplicados si vuelve a elegir el mismo fichero. */
        var repe = elegidos.some(function (g) {
          return g.nombre === f.name && g.size === f.size && g.lastModified === f.lastModified;
        });
        if (repe) return;
        var e = { nombre: f.name, size: f.size, lastModified: f.lastModified, file: null };
        e.promesa = preparar(f).then(function (lista) {
          e.file = lista;
          pintar();
          return lista;
        }, function () {
          /* Ilegible: se quita de la lista y se dice cuál, en vez de fallar
             después al pulsar "Agregar al carrito". */
          var i = elegidos.indexOf(e);
          if (i !== -1) { elegidos.splice(i, 1); huboIlegible = true; }
          sincronizarEstado();
          pintar();
          aviso('No pudimos leer la foto ' + e.nombre + '. Elegila de nuevo o probá con otra.');
          return null;
        });
        elegidos.push(e);
      });
      if (rechazadosPeso) aviso(tpl(errEl, 'data-msg-size', 'Alguna foto supera los 20 MB.'));
      else if (tope) aviso(tpl(errEl, 'data-msg-max', 'Podés subir hasta [max] fotos.').split('[max]').join(MAX_FILES));
      sincronizarEstado();
      pintar();
    }

    function prepararSiguienteSelector(usado) {
      /* Un selector nuevo permite sumar otra tanda sin borrar la FileList que
         mantiene vivos los permisos de la tanda anterior en Android. */
      var siguiente = usado.cloneNode(false);
      /* Chromium clona tambien la FileList interna de un input type=file.
         Solo se limpia la COPIA nueva; el selector usado permanece intacto. */
      siguiente.value = '';
      usado.removeAttribute('data-pp-file');
      usado.removeAttribute('data-required');
      usado.setAttribute('data-pp-source', '');
      usado.insertAdjacentElement('afterend', siguiente);
      input = siguiente;
      enlazarSelector(siguiente);
    }

    function alElegir(e) {
      var usado = e.currentTarget;
      var files = usado.files;
      if (!files || !files.length) return;
      var nuevos = Array.prototype.slice.call(files);
      prepararSiguienteSelector(usado);
      anadir(nuevos);
    }

    function enlazarSelector(selector) {
      selector.addEventListener('change', alElegir);
    }

    trigger.addEventListener('click', function () {
      if (elegidos.length >= MAX_FILES) {
        aviso(tpl(errEl, 'data-msg-max', 'Podés subir hasta [max] fotos.').split('[max]').join(MAX_FILES));
        return;
      }
      input.click();
    });
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); trigger.click(); }
    });

    enlazarSelector(input);

    sincronizarEstado();
    pintar();
  }

  /* ======================================================================
     4. Validación de pasos obligatorios.
        OJO: iurop-cart.js intercepta 'submit' a nivel de document en fase de
        CAPTURA, así que validar en el submit llegaría tarde. Se valida en el
        CLICK del CTA (y en el Enter del input): si falla, preventDefault y
        no llega a generarse ningún submit.
     ====================================================================== */
  function initValidation(root) {
    var form = $('[data-pp-form]', root);
    if (!form) return;

    function validate() {
      var ok = true;
      var ideaInput = $('[data-pp-idea]', form);
      var ideaErr = $('[data-pp-error-idea]', root);
      if (ideaInput && ideaInput.hasAttribute('data-required') && !ideaInput.value.trim()) {
        ok = false;
        if (ideaErr) ideaErr.hidden = false;
        ideaInput.classList.add('has-error');
      } else if (ideaErr) {
        ideaErr.hidden = true;
        if (ideaInput) ideaInput.classList.remove('has-error');
      }
      var fileInput = $('[data-pp-file]', form);
      var upload = $('[data-pp-upload]', form);
      var fileErr = $('[data-pp-error-file]', root);
      var fileCount = parseInt(upload && upload.getAttribute('data-pp-selected-count') || '0', 10);
      if (fileInput && fileInput.hasAttribute('data-required') && fileCount < 1) {
        ok = false;
        if (fileErr) { fileErr.textContent = fileErr.getAttribute('data-msg-required') || 'Subí tu diseño para continuar.'; fileErr.hidden = false; }
      }
      if (!ok) {
        var firstErr = $('[data-pp-error-idea]:not([hidden]), [data-pp-error-file]:not([hidden])', root);
        if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return ok;
    }

    var cta = form.querySelector('[type="submit"]');
    if (cta) cta.addEventListener('click', function (e) {
      if (!validate()) e.preventDefault();
    });
    var idea = $('[data-pp-idea]', form);
    if (idea) {
      /* contador sutil del maxlength (aparece al escribir) */
      var count = $('[data-pp-idea-count]', root);
      var max = parseInt(idea.getAttribute('maxlength'), 10) || 200;
      var syncCount = function () {
        if (!count) return;
        var len = idea.value.length;
        count.textContent = len + '/' + max;
        count.hidden = len === 0;
      };
      idea.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !validate()) e.preventDefault();
      });
      idea.addEventListener('input', function () {
        idea.classList.remove('has-error');
        var err = $('[data-pp-error-idea]', root);
        if (err) err.hidden = true;
        syncCount();
      });
      syncCount();
    }
  }

  /* ======================================================================
     5. Cuenta atrás hasta la hora de corte (TZ configurable)
     ====================================================================== */
  function initCountdown(root) {
    var box = $('[data-pp-countdown]', root);
    if (!box) return;
    var hh = 15, mm = 0;
    var cut = (box.getAttribute('data-cutoff') || '15:00').split(':');
    if (cut.length === 2) { hh = parseInt(cut[0], 10) || 0; mm = parseInt(cut[1], 10) || 0; }
    var tz = box.getAttribute('data-tz') || 'America/Argentina/Buenos_Aires';
    var elH = $('[data-pp-cd-h]', box), elM = $('[data-pp-cd-m]', box), elS = $('[data-pp-cd-s]', box);

    function nowInTz() {
      try {
        return new Date(new Date().toLocaleString('en-US', { timeZone: tz }));
      } catch (e) { return new Date(); }
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = nowInTz();
      var target = new Date(now);
      target.setHours(hh, mm, 0, 0);
      if (target <= now) target.setDate(target.getDate() + 1);
      var diff = Math.max(0, Math.floor((target - now) / 1000));
      var h = Math.floor(diff / 3600), m = Math.floor((diff % 3600) / 60), s = diff % 60;
      if (elH) elH.textContent = pad(h);
      if (elM) elM.textContent = pad(m);
      if (elS) elS.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ======================================================================
     6. Upsells → AJAX + abrir side-cart
     ====================================================================== */
  function initUpsells(root) {
    $all('[data-pp-upsell-add]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!id || btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        var api = window.iuropCartDrawer;
        var done = function () { btn.classList.remove('is-loading'); };
        if (api && api.addItem) {
          api.addItem(id, 1)
            .then(function () { return api.refresh ? api.refresh() : null; })
            .then(function () { if (api.open) api.open(); done(); })
            .catch(function () { done(); });
        } else {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: id, quantity: 1 })
          }).then(function (r) { return r.json(); }).then(function () {
            document.dispatchEvent(new CustomEvent('cart:open'));
            done();
          }).catch(done);
        }
      });
    });
  }

  /* ======================================================================
     7. Carruseles con barras (vídeos y reseñas)
     ====================================================================== */
  function initCarousel(track, bars) {
    if (!track || !bars.length) return;
    var slides = $all('[data-pp-slide]', track);
    if (!slides.length) return;

    function goTo(i) {
      var s = slides[Math.max(0, Math.min(i, slides.length - 1))];
      if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    bars.forEach(function (b, i) {
      b.addEventListener('click', function () { goTo(i); });
    });
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var x = track.scrollLeft, idx = 0, best = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs((s.offsetLeft - track.offsetLeft) - x);
          if (d < best) { best = d; idx = i; }
        });
        bars.forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
      });
    }, { passive: true });
  }

  function initVideos(root) {
    var track = $('[data-pp-videos]', root);
    if (track) initCarousel(track, $all('[data-pp-video-bar]', root));
    $all('[data-pp-video-card]', root).forEach(function (card) {
      var video = $('video', card);
      if (!video) return;
      card.addEventListener('click', function () {
        if (card.classList.contains('is-playing')) return;
        // pausa cualquier otro vídeo en marcha
        $all('[data-pp-video-card].is-playing', root).forEach(function (o) {
          var v = $('video', o);
          if (v) v.pause();
          o.classList.remove('is-playing');
        });
        card.classList.add('is-playing');
        video.play();
      });
      video.addEventListener('ended', function () { card.classList.remove('is-playing'); });
    });
  }

  function initReviews(root) {
    var track = $('[data-pp-reviews]', root);
    if (track) initCarousel(track, $all('[data-pp-review-bar]', root));
    $all('[data-pp-readmore]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-pp-review]');
        if (!card) return;
        var open = card.classList.toggle('is-expanded');
        btn.textContent = open ? 'Leer menos' : 'Leer más';
      });
    });
  }

  /* ======================================================================
     8. Pestañas de descripción
     ====================================================================== */
  function initTabs(root) {
    var tabs = $all('[data-pp-tab]', root);
    var panels = $all('[data-pp-tab-panel]', root);
    if (!tabs.length) return;
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, j) {
          var on = j === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p, j) { p.hidden = j !== i; });
      });
    });
  }

  /* ======================================================================
     8b. Sticky ATC (patrón canónico de iurop-product.js)
        - APARECE SIEMPRE que el CTA principal no está en pantalla: salió por
          ARRIBA (rect.bottom <= 0) O queda bajo el fold (rect.top >=
          innerHeight) — incluida la carga inicial en móvil (QA 5.4).
          Histéresis 48px en ambos bordes anti-parpadeo.
        - Se oculta cerca del footer y con el carrito abierto (iurop-cd-locked).
        - Listener scroll pasivo SÍNCRONO (sin rAF: se congela en 2º plano).
        - El botón sticky hace click() sobre [data-pp-main-cta]: la validación
          de idea+archivo (initValidation) va enganchada al CLICK del CTA;
          form.requestSubmit() directo se la saltaría.
     ====================================================================== */
  function initStickyAtc(root) {
    var stickyBar = document.getElementById('IuropStickyAtc');
    var mainCta = $('[data-pp-main-cta]', root);
    if (!stickyBar || !mainCta) return;

    var stFooter = document.querySelector('.iurop-footer');
    var ST_HYST = 48;        // histéresis anti-parpadeo
    var ST_FOOTER_GAP = 16;  // margen antes del footer para ocultar
    var stShown = false;

    var updateSticky = function () {
      var ctaRect = mainCta.getBoundingClientRect();
      var vh = window.innerHeight;
      // CTA fuera de pantalla (arriba u abajo); histéresis según el estado:
      // ya visible → solo se oculta cuando el CTA asoma ≥48px en el viewport.
      var ctaOff = stShown
        ? (ctaRect.bottom <= ST_HYST || ctaRect.top >= vh - ST_HYST)
        : (ctaRect.bottom <= 0 || ctaRect.top >= vh);
      var nearFooter = false;
      if (stFooter) {
        nearFooter = stFooter.getBoundingClientRect().top <= (vh - ST_FOOTER_GAP);
      }
      var cartOpen = document.documentElement.classList.contains('iurop-cd-locked');
      var show = ctaOff && !nearFooter && !cartOpen;
      if (show !== stShown) {
        stShown = show;
        stickyBar.classList.toggle('is-visible', show);
        document.body.classList.toggle('iurop-sticky-atc-visible', show);
      }
    };
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    document.addEventListener('cart:updated', updateSticky);
    document.addEventListener('iurop:cart:toggle', updateSticky);
    document.addEventListener('visibilitychange', updateSticky);
    window.addEventListener('pageshow', updateSticky);
    updateSticky();

    $all('[data-iurop-sticky-submit]', stickyBar).forEach(function (btn) {
      btn.addEventListener('click', function () {
        // NUNCA form.requestSubmit(): saltaría la validación de initValidation.
        // Si la validación falla, su scrollIntoView ya lleva al usuario al error.
        mainCta.click();
      });
    });
  }

  /* ======================================================================
     9. Properties visibles en el side-cart (sin tocar el chrome)
        El drawer re-pinta sus líneas con innerHTML: observamos la lista y
        tras cada render inyectamos las properties leyendo /cart.js.
     ====================================================================== */
  var cartCache = null;
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartCache = c; return c; });
  }
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) cartCache = e.detail.cart;
    decorateDrawer();
  });

  function propHTML(name, value) {
    var isUrl = /^https?:\/\//.test(value);
    var v = isUrl
      ? '<a href="' + esc(value) + '" target="_blank" rel="noopener">Ver archivo</a>'
      : esc(value);
    return '<p class="iurop-pp-cd-prop"><span>' + esc(name) + ':</span> ' + v + '</p>';
  }

  function decorateDrawer() {
    var list = $('#CartDrawer [data-cd-items]');
    if (!list) return;
    var apply = function (cart) {
      if (!cart || !cart.items) return;
      $all('[data-cd-item]', list).forEach(function (li) {
        if (li.querySelector('.iurop-pp-cd-props')) return; // ya decorada
        var key = li.getAttribute('data-key');
        var item = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === key) { item = cart.items[i]; break; }
        }
        if (!item || !item.properties) return;
        var html = '';
        for (var name in item.properties) {
          if (!Object.prototype.hasOwnProperty.call(item.properties, name)) continue;
          if (name.charAt(0) === '_') continue; // properties privadas
          var val = item.properties[name];
          if (val == null || val === '') continue;
          html += propHTML(name, String(val));
        }
        if (!html) return;
        var target = li.querySelector('.iurop-cd__item-top') || li;
        var div = document.createElement('div');
        div.className = 'iurop-pp-cd-props';
        div.innerHTML = html;
        target.appendChild(div);
      });
    };
    if (cartCache) apply(cartCache); else fetchCart().then(apply);
  }

  function observeDrawer() {
    var list = $('#CartDrawer [data-cd-items]');
    if (!list) return;
    new MutationObserver(function () { decorateDrawer(); }).observe(list, { childList: true });
    decorateDrawer();
  }

  /* ======================================================================
     init
     ====================================================================== */
  function init() {
    var root = $('[data-iurop-personalizar]');
    if (root) {
      initQuantity(root);
      initVariants(root);
      initUpload(root);
      initValidation(root);
      initCountdown(root);
      initUpsells(root);
      initVideos(root);
      initReviews(root);
      initTabs(root);
      initStickyAtc(root);
    }
    observeDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
